import React from 'react';

import { defaults, usePredefined, useServices } from '../../Data/Services';
import NoValue from '../EmptyStates/NoValue';
import { classNames } from '../../Services/helpers';

const Services = ({ services: listedServices, ul, className }) => {
    const {services} = useServices();
    const {predefined} = usePredefined()

    if (!listedServices) {
        return <NoValue />
    }

    const getTitle = (service) => {
        let found = services ? services.find(s => s.type === service) : null;
        let pre = predefined ? predefined.find(cat => cat.services.find(s => s.type === service)) : null;

        if (found) {
            return found.title;
        }

        if (pre) {
            return pre.title;
        }

        found = defaults.find(s => s.type === service);

        return found ? found.title : service;
    };

    const titled = listedServices.map(service => getTitle(service));

    if (ul) {
        return <ul className={classNames('list-unstyled mb-0', className)}>
            {titled.map((service, i) => <li key={service + i}>{getTitle(service)}</li>)}
        </ul>
    }

    return <span className={className}>{titled.join(', ')}</span>;
}

const getServiceString = (serviceIds, services) => {
    if (!services || !serviceIds) {
        return '';
    }

    const titles = services.filter(s => serviceIds.includes(s.type)).map(s => s.title);

    return titles.join(', ');
}

export default Services;

export {
    getServiceString
}
